<mat-card>
  <mat-card-title>Cette page vous permet d'accéder aux formulaires archivés, formulaires qui ne sont plus utilisés</mat-card-title>
  <mat-card-content fxLayout="column">
    <app-data-table
      [actions]="actions"
      [columns]="columns"
      [dataSource]="dsFormulaires"
      [extraParams]="extraParams"
      [filterDisplay]="true"
      [flexAction]="5"
      [flexColumn]="90"
      [fontSizeCell]="'0.9em'"
      [minFilter]="1" [pageSize]="10"
      [pageSizesList]="[5,10,25]" [placeHolderFilter]="'Rechercher des formulaires'"
      [refreshButton]="true"
      [refreshIcone]="false"
      [showFirstLastButtons]="true"
      [showLoader]="true"
      [loaderMask]="true"
      [toolTipFilter]="'Recherche de formulaire'">
    </app-data-table>
  </mat-card-content>
</mat-card>
